import type { DocBlock, DocBlockType, DocNestedBlock } from "./blockTypes";
import type { DocNestedBlockType } from "./blockNested";
import { createDefaultTableRows } from "./blockTableHelpers";

export function newBlockId(): string {
  return crypto.randomUUID();
}

export function createDocBlock(type: DocBlockType, sortOrder: number): DocBlock {
  const base = { id: newBlockId(), type, sort_order: sortOrder };
  switch (type) {
    case "heading":
      return { ...base, type: "heading", level: 1, text: "" };
    case "paragraph":
      return { ...base, type: "paragraph", text: "" };
    case "rich_text":
      return { ...base, type: "rich_text", body: "" };
    case "text_field":
      return { ...base, type: "text_field", label: "", variable_key: "" };
    case "freeform_field":
      return { ...base, type: "freeform_field", label: "", variable_key: "" };
    case "number_field":
      return { ...base, type: "number_field", label: "", variable_key: "" };
    case "formula_field":
      return { ...base, type: "formula_field", label: "", key: "", expression: "" };
    case "checkbox":
      return {
        ...base,
        type: "checkbox",
        label: "",
        fillable: false,
        checked: false,
        variable_key: "",
      };
    case "signature_line":
      return {
        ...base,
        type: "signature_line",
        printed_name_label: "Printed name",
        printed_name_variable_key: "",
        signature_caption: "Signature",
        signature_variable_key: "",
        date_label: "Date",
        date_variable_key: "",
      };
    case "table":
      return {
        ...base,
        type: "table",
        header_row: true,
        rows: createDefaultTableRows(2, 2),
      };
    case "two_column":
      return {
        ...base,
        type: "two_column",
        left: [createDocNestedBlock("paragraph", 0)],
        right: [createDocNestedBlock("paragraph", 0)],
      };
    case "image":
      return { ...base, type: "image", asset_id: "", alt: "", caption: "" };
    case "divider":
      return { ...base, type: "divider" };
    case "page_break":
      return { ...base, type: "page_break" };
    default: {
      const _exhaustive: never = type;
      return _exhaustive;
    }
  }
}

export function createDocNestedBlock(type: DocNestedBlockType, sortOrder: number): DocNestedBlock {
  const block = createDocBlock(type as DocBlockType, sortOrder);
  return block as DocNestedBlock;
}
